<template>
	<div class="content">
		<div class="questionbox">
			<div v-if="effect_datas.length !== 0" style="padding: 0 10px;">
				<div class="conutd">
					{{h}}小时{{ m }}分钟 {{ s }}秒
				</div>
				<div class="examtitle">
					<div class="an-title">
						<!--            <div class="num">{{ examindex + 1 }}.</div>-->
						<div class="tis" v-if="effect_datas[examindex].xm == '战略题'">
							<div class="s"
								v-if="effect_datas[examindex].xm == '战略题'&&effect_datas[examindex].index == 1">
								对于股权的规划和实施中，我对股权的布局和思考的阐述内容认同的是：</div>
							<div class="ti">{{effect_datas[examindex].index}}、{{effect_datas[examindex].tm}}</div>
						</div>
						<div class="tis" v-else>
							<div class="tiwen">组织股权{{ effect_datas[examindex].xm}}方面：</div>
							<div class="ti">
								{{effect_datas[examindex].index}}、对于{{ effect_datas[examindex].xm}}方面，在{{effect_datas[examindex].xc}}时，目前（未来）思考作业方式：
							</div>
						</div>
					</div>
				</div>
				<div class="answer-list">
					<el-radio-group class="form" v-model="choise[examindex]">
						<el-radio
							@change="e=>answerChange(e,effect_datas[examindex].id,item,effect_datas[examindex].xc,effect_datas[examindex].xm,effect_datas[examindex].xx_json)"
							class="examradio" v-for="(item,index) in effect_datas[examindex].xx_json" :key="index"
							:label="index">
							{{index}}
						</el-radio>
					</el-radio-group>
				</div>
			</div>
			<div class="btngroup">
				<div>
					<el-button :type="examindex == 0 ? 'default':'success'" @click="preexam">上一题
					</el-button>
				</div>
				<div style="margin-left: 40px;" v-if="examindex != effect_datas.length-1">
					<el-button type="success" @click="nextexam">下一题</el-button>
				</div>
				<div style="margin-left: 40px;" v-else>
					<el-button type="success" @click="submit()">提交</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	var indexurl = localStorage.getItem('url')
	export default {
		data() {
			return {
				urlCode: '',
				examindex: 0,
				effect_dataindex: 0,
				exam: [],
				choise: {},
				choises: {},
				h: 0,
				m: 0,
				s: 0,
				scores: [],
				effect_datas: [],
				shows: false,
				datas: [],
				cepingren: [],
				countdownTime: 4 * 60
			}
		},
		created() {
			this.getURL()
			this.getQuestion()
		},
		mounted() {
			this.pingxe()
			this.setTimer()
			this.setTimeData(this.countdownTime * 60 * 1000);
		},
		methods: {
			getURL() {
				let url = window.location.href
				this.urlCode = url.substring(url.indexOf("=") + 1)
			},
			pingxe() {
				let that = this
				this.$axios({
					method: "get",
					url: indexurl + "/index.php/api/index/getVisitorInfo?key=" + that.urlCode,
					data: {}
				}).then(res => {
					that.cepingren = res.data.data
				})
			},
			shuffleObject(obj) {
			  let keys = Object.keys(obj);
			  let values = Object.values(obj);
			 
			  // 使用Fisher-Yates算法打乱数组
			  for (let i = keys.length - 1; i > 0; i--) {
			    let j = Math.floor(Math.random() * (i + 1));
			    [keys[i], keys[j]] = [keys[j], keys[i]];
			    [values[i], values[j]] = [values[j], values[i]];
			  }
			 
			  // 根据打乱后的键和值重新构建对象
			  let shuffled = {};
			  for (let i = 0; i < keys.length; i++) {
			    shuffled[keys[i]] = values[i];
			  }
			 
			  return shuffled;
			},
shuffle(array) {
  let currentIndex = array.length, temporaryValue, randomIndex;

  // 当还剩有元素未洗牌时
  while (0 !== currentIndex) {

    // 选取剩下的元素...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // 并与当前元素交换。
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
},
			getQuestion() {
				let that = this
				this.$axios({
					method: "get",
					url: indexurl + "/index.php/api/index/questionsData?key=" + that.urlCode,
					data: {}
				}).then(res => {
					let arr = []
					res.data.data.map(item => {
						const originalObjects = JSON.parse(item.xx_json)
						let entries = Object.entries(originalObjects);
						for (let i = entries.length - 1; i > 0; i--) {
							let j = Math.floor(Math.random() * (i + 1));
							[entries[i], entries[j]] = [entries[j], entries[i]];
						}
						// let xi = entries
						console.log(entries,'entries');
						var objs = {};
						for (var i = 0; i < entries.length; i++) {
							objs[entries[i][0]] = entries[i][1];
						}
						console.log(objs, 'fghjkzz最终结果');
						// const shuffledObject = this.shuffleObject(originalObjects);
						// console.log(shuffledObject);
						item.xx_json = objs
						// item.xx_json = JSON.parse(item.xx_json)
						arr.push(item)
					})
					let arrs = []
					let arrss = []
					arr.map((item, index) => {
						if (item.xm == '战略题') {
							arrs.push(item)
						}
					})
					arr.map((item, index) => {
						if (item.xm != '战略题') {
							arrss.push(item)
						}
					})
					const shuffledArray = this.shuffle(arrs);
					const shuffledArrays = this.shuffle(arrss);
					shuffledArray.map((item,index) => {
						console.log(item,index,'hj');
						item.index = Number(index) + 1
					})
					shuffledArrays.map((item,index) => {
						console.log(item,index,'hj');
						item.index = Number(index) + 1
					})
					const combinedArray = shuffledArray.concat(shuffledArrays);
					that.effect_datas = combinedArray
				})
			},
			answerChange(e, id, i, xc, xm, xx_json) {
				this.datas[this.examindex] = {
					id: id,
					answer: e,
					fenshu: i,
					xc: xc,
					xm: xm,
					xx_json: xx_json
				}
			},
			nextexam() {
				let kaiguan = true
				if (this.examindex == 4) {
					let list = this.datas
					list.map(item => {
						console.log(item.fenshu)
						if (item.fenshu == 0) {
							kaiguan = false
						}
					})
					if (kaiguan) {
						this.$message({
							type: 'warning',
							message: 'PASS 恭喜战略性5D诊断成功!请对股权5D战术性诊断!'
						});
					} else {
						this.$message({
							type: 'warning',
							message: 'FAIL 注意战略性5D诊断失败!请对股权5D战术性诊断!'
						});
					}
				}
				if (this.datas[this.examindex]) {
					this.examindex = this.examindex + 1
				} else {
					this.$message({
						type: 'warning',
						message: '请选择答案'
					});
					return
				}

			},
			preexam() {
				if (this.examindex != 0) {
					this.examindex = this.examindex - 1
				}
			},
			submit() {
				console.log(this.datas, this.urlCode)
				let that = this
				let loading
				loading = this.$loading({
					lock: true,
					text: "上传中，请稍后",
					spinner: "el-icon-loading",
					background: "rgba(0, 0, 0, 0.7)",
				});
				this.$axios({
					method: "POST",
					url: indexurl + "/index.php/api/index/postResult",
					data: {
						data: this.datas,
						key: this.urlCode,
					}
				}).then(res => {
					loading.close()
					this.to()
				})
			},
			setTimeData(cm) {
				this.h = Math.floor((cm / 1000 / 60 / 60) % 24);
				this.h =
					this.h.toString().length == 1 ? "0" + this.h : this.h;
				this.m = Math.floor((cm / 1000 / 60) % 60);
				this.m =
					this.m.toString().length == 1 ? "0" + this.m : this.m;
				this.s = Math.floor((cm / 1000) % 60);
				this.s =
					this.s.toString().length == 1 ?
					"0" + this.s :
					this.s;
			},
			setTimer() {
				let _this = this;
				this.interval = setInterval(function() {
					_this.payCountdown(_this.countdownTime * 60 * 1000);
					clearInterval(_this.interval);
				}, 1000);
			},
			payCountdown(cm) {
				let _this = this;
				if (cm >= 0) {
					this.h = Math.floor((cm / 1000 / 60 / 60) % 24);
					this.h =
						this.h.toString().length == 1 ? "0" + this.h : this.h;
					this.m = Math.floor((cm / 1000 / 60) % 60);
					this.m =
						this.m.toString().length == 1 ?
						"0" + this.m :
						this.m;
					this.s = Math.floor((cm / 1000) % 60);
					this.s =
						this.s.toString().length == 1 ?
						"0" + this.s :
						this.s;
					let _msThis = this;
					setTimeout(function() {
						cm -= 1000;
						_msThis.payCountdown(cm);
					}, 1000);
				}
			},
			to(urlCode) {
				this.$router.push({
					path: '/components/cha',
					query: {
						urlCode: this.urlCode
					}
				})
			}
		}
	}
</script>

<style scoped>
	.content {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		padding-top: 20px;
		padding-bottom: 20px;
		height: 100vh;
	}

	.examradio {
		/*width: 100%;*/
		line-height: 25px;
	}

	.form {
		display: flex;
		flex-direction: column;
		width: 100%;
	}

	.examtitle {
		display: flex;
		justify-content: space-between;
	}

	.an-title {
		display: flex;
	}

	.othen {
		flex-direction: column;
		justify-content: space-between;
		transition: all 0.5s ease-in-out;
	}

	.btngroup {
		display: flex;
		justify-content: space-around;
		align-content: center;
		margin-top: 25px;
	}

	.conutd {
		text-align: end;
		padding: 10px 0;
	}

	.questionbox {
		width: 50%;
		padding: 20px;
		box-shadow: 0 0 10px 10px rgba(0, 0, 0, 0.3);
		border-radius: 10px;
		/* position: absolute; */
		/* transform: translateY(-50%); */
		/* top: 50%; */
	}

	.num {
		font-size: 25px;
		font-weight: bold;
	}

	.ti {
		font-size: 22px;
	}

	.tishi_ti {
		color: red;
		font-size: 16px;
		margin-top: 15px;
	}

	.yangshi {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}


	@media (max-width: 850px) {
		.questionbox {
			width: 70%;
			transition: all 0.5s ease-in-out;
		}
	}

	@media (max-width: 768px) {
		.examtitle {
			flex-direction: column;
		}

		.conutd {
			text-align: end;
			padding: 10px 0;
		}

		.questionbox {
			width: 80%;
			transition: all 0.5s ease-in-out;
			position: unset;
			transform: unset;
		}

		.el-radio {
			white-space: unset;
			margin-right: 0;
			margin-top: 10px;
		}

	}

	.form>>>.el-radio {
		white-space: unset;
	}

	.tiwen {
		color: red;
		font-size: 24px;
	}
</style>


// WEBPACK FOOTER //
// src/components/answer/index.vue